/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ presetName: NonNullable<unknown> }} Styles_Delete_Preset_Confirm_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{presetName}\"?" |
*
* @param {Styles_Delete_Preset_Confirm_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_delete_preset_confirm_text = /** @type {((inputs: Styles_Delete_Preset_Confirm_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Delete_Preset_Confirm_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Etes-vous sur de vouloir supprimer "${i?.presetName}"?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchten Sie "${i?.presetName}" wirklich löschen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare "${i?.presetName}"?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить "${i?.presetName}"?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`¿Estás seguro de que deseas eliminar "${i?.presetName}"?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`您确定要删除“${i?.presetName}”吗？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`「${i?.presetName}」を削除してもよろしいですか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`क्या आप वाकई "${i?.presetName}" को हटाना चाहते हैं?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir "${i?.presetName}"?`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.presetName}"?`)
});